<div class="tw-bg-slate-100 tw-w-1/3 tw-rounded tw-m-auto tw-p-4 tw-mb-4">
  <div class="tw-text-sm tw-text-slate-500">
    <p class="tw-font-bold">Informações</p>
    <p><span class="tw-font-bold tw-text-blue-600">Id:</span> {{ processId }}</p>
    <p><span class="tw-font-bold tw-text-blue-600">Nome do processo:</span> {{ processName }}</p>
    <p>
      <span class="tw-font-bold tw-text-blue-600">Processo criado em:</span>
      {{ processCreatedDate | date: 'dd/MM/yyyy' }}
    </p>
  </div>
  <p-divider></p-divider>
  <div class="tw-text-sm tw-text-slate-500">
    <div class="tw-flex tw-flex-col tw-gap-4 tw-mt-4">
      <div class="tw-flex tw-items-center tw-gap-2">
        <span>Iniciado</span>
        <i class="pi pi-circle tw-text-blue-500"></i>
      </div>
      <div class="tw-flex tw-items-center tw-gap-2">
        <span>Em processamento</span>
        <i class="pi pi-hourglass tw-text-yellow-500"></i>
      </div>
      <div class="tw-flex tw-items-center tw-gap-2">
        <span>Finalizado</span>
        <i class="pi pi-check-circle tw-text-green-500"></i>
      </div>
    </div>
  </div>
</div>
